import React from "react";
import styles from "./ClinicDesktopPageBanner.module.scss";
import classnames from "classnames";
import MyLatestOrderTile from "@src/components/widgets/MyLatestOrderTile";
import { addStaticRootToUrl } from "@src/utils/static";
import MaxWidthContainer from "@src/components/containers/MaxWidthContainer";
import RequiresPermissionContainer from "@src/components/containers/RequiresPermissionContainer";
import Permissions from "@src/constants/Permissions";
import PermissionLevels from "@src/constants/PermissionLevels";

export default function ClinicDesktopPageBanner(): React.JSX.Element {
  return (
    <MaxWidthContainer>
      <div className="flex-row">
        <div id="promo-hero" className="flex-2">
          <div
            className={styles.productImageRoot}
            style={{
              backgroundImage: `url(${addStaticRootToUrl("images/clinic_desktop_page_banner_background.png")})`,
            }}
          >
            <div>
              <h1>Make the Adventure Last</h1>
              <div className={styles.subheader}>
                Keep your best friend active, adventurous, and pain-free
              </div>
            </div>
            <img
              className={styles.productImage}
              src={addStaticRootToUrl(
                "images/clinic_desktop_page_banner_product_placeholder.png",
              )}
            />
          </div>
        </div>
        <div className="flex-1 background-success padding-xl">
          <RequiresPermissionContainer
            permission={{
              slug: Permissions.Orders,
              level: PermissionLevels.View,
            }}
          >
            <MyLatestOrderTile />
          </RequiresPermissionContainer>
        </div>
      </div>
      <div
        id="promo-banner"
        className={classnames(styles.joinRewardsPrompt, "spaced-content-lg")}
      >
        <span className={classnames(styles.saveMore)}>
          <span className="text-italic font-weight-boldest">
            <span>Save even more when you order</span>
            &nbsp;
            <span className="text-success">easy!</span>
          </span>
        </span>
        <span className="text-md font-weight-bold">Join OE Rewards today!</span>
      </div>
    </MaxWidthContainer>
  );
}
